module.exports = __webpack_public_path__ + "assets/img/heart-gray.d49e2e76.svg";